/* eslint-disable */
import { THEME_TOGGLE_PALETTE_TYPE } from '../Theme.types';

/**
 * Toggle the type of the current palette
 * @returns {ActionCreator<FromPayload<null, {}, THEME_TOGGLE_PALETTE_TYPE>>} The created `Action`
 */
const themeTogglePaletteType = () => ({ fromPayload }) => {
  return fromPayload(null, {}, THEME_TOGGLE_PALETTE_TYPE);
};

export default themeTogglePaletteType;
